HuesMdl.controller( 'SingleHueCtrl', ['$scope', '$state', 'HuesSrv',  function ( $scope, $state, HuesSrv ) {

}]);
